import React, { useState } from "react";
import FilterHeader from "../../Components/FilterHeader/FilterHeader";
import {
  Button,
  Chip,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { More } from "@mui/icons-material";
import ImageSearchIcon from "@mui/icons-material/ImageSearch";
import ChangeCircleIcon from "@mui/icons-material/ChangeCircle";
import { useTheme, useMediaQuery } from "@mui/material";
import PatternIcon from "@mui/icons-material/Pattern";
const BandhanRegistrationTable = ({
  backDrowLoading,
  data,
  searchType,
  setSearchType,
  searchTerm,
  setSearchTerm,
  dateRange,
  setDateRange,
  total,
  page,
  setPage,
  rowsPerPage,
  setRowsPerPage,
  handleEdit,
  fetchImag,
  handleResetPassword,
}) => {
  // # region
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const [openView, setOpenView] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const handleViewMore = (row) => {
    setSelectedRow(row);
    setOpenView(true);
  };

  const handleClose = () => {
    setOpenView(false);
    setSelectedRow(null);
  };

  const [openImg, setOpenImg] = useState(false);
  const [images, setImages] = useState(null);
  const handleViewImage = async (row) => {
    const res = await fetchImag(row.id); // 👈 parent function call
    if (res) {
      setImages(res);
      setOpenImg(true);
    }
  };

  //#endregion
  return (
    <>
      <Dialog open={openView} onClose={handleClose} maxWidth="md" fullWidth>
        <DialogTitle>Registration Details</DialogTitle>

        <DialogContent dividers>
          {selectedRow && (
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <b>Reg No:</b> {selectedRow.registration_no}
              </Grid>
              <Grid item xs={6}>
                <b>Name:</b> {selectedRow.name}
              </Grid>

              <Grid item xs={6}>
                <b>Self / Other:</b> {selectedRow.self_or_other}
              </Grid>
              <Grid item xs={6}>
                <b>Gender:</b> {selectedRow.gender}
              </Grid>

              <Grid item xs={6}>
                <b>DOB:</b> {selectedRow.date_of_birth}
              </Grid>
              <Grid item xs={6}>
                <b>Time:</b> {selectedRow.time_of_birth}
              </Grid>

              <Grid item xs={6}>
                <b>Place:</b> {selectedRow.place_of_birth}
              </Grid>
              <Grid item xs={6}>
                <b>Blood Group:</b> {selectedRow.blood_group}
              </Grid>

              <Grid item xs={6}>
                <b>Education:</b> {selectedRow.highest_education_one}
              </Grid>
              <Grid item xs={6}>
                <b>Profession:</b> {selectedRow.profession}
              </Grid>

              <Grid item xs={6}>
                <b>Income:</b> ₹{selectedRow.monthly_income}
              </Grid>
              <Grid item xs={6}>
                <b>Height:</b> {selectedRow.height}
              </Grid>

              <Grid item xs={6}>
                <b>Father:</b> {selectedRow.father_name}
              </Grid>
              <Grid item xs={6}>
                <b>Father Occupation:</b> {selectedRow.father_occupation}
              </Grid>
              <Grid item xs={6}>
                <b>Mother:</b> {selectedRow.mother_name}
              </Grid>
              <Grid item xs={6}>
                <b>Mother Occupation:</b> {selectedRow.mother_occupation}
              </Grid>

              <Grid item xs={6}>
                <b>Gotra:</b> {selectedRow.gotra_name}
              </Grid>
              <Grid item xs={6}>
                <b>Kuldevi:</b> {selectedRow.kuldevi_name}
              </Grid>

              <Grid item xs={6}>
                <b>Phone:</b> {selectedRow.phone}
              </Grid>
              <Grid item xs={6}>
                <b>Email:</b> {selectedRow.email}
              </Grid>

              <Grid item xs={6}>
                <b>Address:</b> {selectedRow.correspondence_address}
              </Grid>
              <Grid item xs={6}>
                <b>Sibling1:</b> {selectedRow.sibling1}
              </Grid>
              <Grid item xs={6}>
                <b>Sibling1 Profession:</b> {selectedRow.profession1}
              </Grid>
              <Grid item xs={6}>
                <b>Sibling2 :</b> {selectedRow.sibling2}
              </Grid>
              <Grid item xs={6}>
                <b>Sibling2 Profession:</b> {selectedRow.profession2}
              </Grid>
              <Grid item xs={6}>
                <b>Sibling3 :</b> {selectedRow.sibling3}
              </Grid>
              <Grid item xs={6}>
                <b>Sibling3 Profession:</b> {selectedRow.profession3}
              </Grid>
              <Grid item xs={6}>
                <b>Dadaji:</b> {selectedRow.dadaji}
              </Grid>
              <Grid item xs={6}>
                <b>DadIji:</b> {selectedRow.dadiji}
              </Grid>
              <Grid item xs={6}>
                <b>Nanaji:</b> {selectedRow.Nanaji}
              </Grid>

              <Grid item xs={6}>
                <b>Naniji:</b> {selectedRow.naniji}
              </Grid>
              <Grid item xs={6}>
                <b>References1:</b> {selectedRow.references1}
              </Grid>
              <Grid item xs={6}>
                <b>References2:</b> {selectedRow.references2}
              </Grid>
              <Grid item xs={6}>
                <b>References3:</b> {selectedRow.references3}
              </Grid>
            </Grid>
          )}
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>
      </Dialog>

      {/* image  */}

      <Dialog
        open={openImg}
        onClose={() => setOpenImg(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Uploaded Images</DialogTitle>

        <DialogContent dividers>
          {images ? (
            <Grid container spacing={2}>
              {images.image1 && (
                <Grid item xs={12} md={4}>
                  <img
                    src={images.image1}
                    alt="Image 1"
                    style={{ width: "100%", borderRadius: 8 }}
                  />
                </Grid>
              )}

              {images.image2 && (
                <Grid item xs={12} md={4}>
                  <img
                    src={images.image2}
                    alt="Image 2"
                    style={{ width: "100%", borderRadius: 8 }}
                  />
                </Grid>
              )}

              {images.image3 && (
                <Grid item xs={12} md={4}>
                  <img
                    src={images.image3}
                    alt="Image 3"
                    style={{ width: "100%", borderRadius: 8 }}
                  />
                </Grid>
              )}
            </Grid>
          ) : (
            <Typography align="center">No images found</Typography>
          )}
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpenImg(false)}>Close</Button>
        </DialogActions>
      </Dialog>

      <FilterHeader
        total={total}
        searchType={searchType}
        setSearchType={setSearchType}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        dateRange={dateRange}
        setDateRange={setDateRange}
        downloadExcel={() => alert("Downloading Excel...")}
        downloadPDF={() => alert("Downloading PDF...")}
        searchOptions={[
          { value: "name", label: " Name" },
          { value: "email", label: "Email" },
          { value: "unique_code", label: "code" },
        ]}
        showDatePicker={false}
        showExcel={false}
        showPDF={false} // 🔽 can hide PDF easily
      />

      {isMobile ? (
        // 🔹 MOBILE VIEW (BOX / CARD DESIGN)
        data?.length > 0 ? (
          data.map((row, index) => (
            <>
              <Paper key={index} sx={{ p: 2, mb: 2 }}>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <b>S.No:</b> {index + 1}
                  </Grid>
                  <Grid item xs={12}>
                    <b>Reg No:</b> {row.registration_no}
                  </Grid>
                  <Grid item xs={12}>
                    <b>Name:</b> {row.name}
                  </Grid>
                  <Grid item xs={12}>
                    <b>Father:</b> {row.father_name}
                  </Grid>
                  <Grid item xs={12}>
                    <b>Phone:</b> {row.phone}
                  </Grid>
                  <Grid item xs={12}>
                    <Chip
                      label={row.status ? "Active" : "Inactive"}
                      color={row.status ? "success" : "default"}
                      size="small"
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <IconButton size="small" onClick={() => handleEdit(row)}>
                      <EditIcon fontSize="small" />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => handleViewMore(row)}
                    >
                      <More fontSize="small" />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => handleViewImage(row)}
                    >
                      <ImageSearchIcon fontSize="small" />
                    </IconButton>
                    <IconButton
                      size="small"
                      sx={{ ml: 1 }}
                      onClick={() => handleResetPassword(row.id)}
                    >
                      <PatternIcon fontSize="small" />
                    </IconButton>
                  </Grid>
                </Grid>
              </Paper>
              <TablePagination
                component="div"
                count={total}
                page={page - 1}
                onPageChange={(e, newPage) => setPage(newPage + 1)}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={(e) => {
                  setRowsPerPage(parseInt(e.target.value, 10));
                  setPage(1);
                }}
                rowsPerPageOptions={[10, 25, 50]}
              />
            </>
          ))
        ) : (
          <Typography align="center">No records found</Typography>
        )
      ) : (
        // 🔹 DESKTOP VIEW (YOUR EXISTING TABLE)
        <>
          {/* 👉 Yaha tumhara SAME TableContainer wala code rahega */}
          <TableContainer component={Paper}>
            <Table size="small">
              <TableHead>
                <TableRow sx={{ backgroundColor: "#1976d2" }}>
                  <TableCell sx={{ color: "#fff" }}>
                    <b>Sno.</b>
                  </TableCell>
                  {/* <TableCell sx={{ color: "#fff" }}>
              <b>Self / Other</b>
            </TableCell> */}
                  <TableCell sx={{ color: "#fff" }}>
                    <b>Registration No.</b>
                  </TableCell>
                  <TableCell sx={{ color: "#fff" }}>
                    <b>Name</b>
                  </TableCell>
                  {/* <TableCell sx={{ color: "#fff" }}>
              <b>DOB</b>
            </TableCell> */}
                  <TableCell sx={{ color: "#fff" }}>
                    <b>Father Name</b>
                  </TableCell>
                  <TableCell sx={{ color: "#fff" }}>
                    <b>Phone</b>
                  </TableCell>
                  <TableCell sx={{ color: "#fff" }}>
                    <b>Status</b>
                  </TableCell>
                  <TableCell sx={{ color: "#fff" }}>
                    <b>Action</b>
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {data?.length > 0 ? (
                  data.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell>{index + 1}</TableCell>

                      {/* <TableCell>{row.self_or_other}</TableCell> */}
                      <TableCell>{row.registration_no}</TableCell>
                      <TableCell>{row.name}</TableCell>
                      {/* <TableCell>{row.date_of_birth}</TableCell> */}
                      <TableCell>{row.father_name}</TableCell>
                      <TableCell>{row.phone}</TableCell>
                      <TableCell>
                        <Chip
                          label={row.status ? "Active" : "Inactive"}
                          color={row.status ? "success" : "default"}
                          size="small"
                        />
                      </TableCell>
                      <TableCell>
                        <Grid
                          container
                          wrap="nowrap"
                          alignItems="center"
                          justifyContent="center"
                        >
                          <IconButton
                            size="small"
                            sx={{ ml: 1 }}
                            onClick={() => handleEdit(row)}
                          >
                            <EditIcon fontSize="small" />
                          </IconButton>

                          <IconButton
                            size="small"
                            sx={{ ml: 1 }}
                            onClick={() => handleViewMore(row)}
                          >
                            <More fontSize="small" />
                          </IconButton>

                          <IconButton
                            size="small"
                            sx={{ ml: 1 }}
                            onClick={() => handleViewImage(row)}
                          >
                            <ImageSearchIcon fontSize="small" />
                          </IconButton>
                          <IconButton
                            size="small"
                            sx={{ ml: 1 }}
                            onClick={() => handleResetPassword(row.id)}
                          >
                            <PatternIcon fontSize="small" />
                          </IconButton>
                        </Grid>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={10} align="center">
                      No records found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            component="div"
            count={total}
            page={page - 1}
            onPageChange={(e, newPage) => setPage(newPage + 1)}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={(e) => {
              setRowsPerPage(parseInt(e.target.value, 10));
              setPage(1);
            }}
            rowsPerPageOptions={[10, 25, 50]}
          />
        </>
      )}
    </>
  );
};

export default BandhanRegistrationTable;
